<style lang="stylus">
    .aidraw-modal-container
        width 928px
        height 640px
        border none
        overflow hidden
        .title-close
            top 4px
            right 0
        .header-prefix
            float left
            display flex
            align-items center
            margin 10px 0 0 12px
            font-weight 400
            > p
                margin 0 4px
                color #000
            .ivu-tooltip-arrow
                border-bottom-color var(--border-color-tips) !important
            .ivu-tooltip-inner
                background-color var(--bg-color-tips) !important
                border-radius 8px
                p
                    line-height 20px
                    color #fff
                    font-size 12px
        .tips-mark
            cursor default
            .ivu-tooltip-rel
                display flex
        .dialog-slot
            padding 0 !important
        iframe
            display block
            width 100%
            height 640px
</style>

<template>
    <Dialog ref="dialogDom" class="aidraw-modal-container" :isShow="true" :hiddenTitle="true" @close="closeDialog">
        <iframe ref="aidrawWin" :src="url" frameborder="0" @load="aidrawWinLoad"></iframe>
    </Dialog>
</template>

<script lang="ts">
    import { Component, Prop, Vue, Watch } from "vue-property-decorator";
    import Dialog from "../Dialog.vue";

    @Component({
        components: {
            Dialog,
        },
    })
    export default class Iconfont extends Vue {
        imgDom = null;
        svgData = {
            svg: "",
            w: "",
            h: "",
            color: "",
        };

        get focusModeExpandLeft() {
            return this.$store.getters.expandLeft;
        }
        get sceneLeft() {
            if (!this.focusModeExpandLeft) return 0;
            return this.$store.state.ui.sceneLeft;
        }
        get focusModeExpandTop() {
            return this.$store.getters.expandTop;
        }
        get sceneTop() {
            if (!this.focusModeExpandTop) return 0;
            return this.$store.state.ui.sceneTop;
        }
        get url() {
            const host = "https://www.edrawmax.cn/public/ai-painting/";
            const hostEn = "https://www.edrawmax.com/public/ai-painting/";
            const hostEntest = "https://wmp.edrawsoft.cn/en/ai-painting/";
            const hostCntest = "https://wmp.edrawsoft.cn/cn/ai-painting/";
            if (this.isTestEnv) {
                return `${this.internal ? hostCntest : hostEntest}?v=1&platform=web&lang=${this.lang}`;
            } else {
                return `${this.internal ? host : hostEn}?v=1&platform=web&lang=${this.lang}`;
            }
        }
        closeDialog() {
            this.$store.commit("setDialogState", {
                type: "showDialog",
                data: false,
            });

            this.sensors.track("close_AI_painting", {
                Catalogues: "AI",
            });
        }
        get userInfo() {
            return this.$store.getters.apiParam;
        }
        get pointLink() {
            const availableLang = ["de", "fr", "es", "pt", "it", "jp"].includes(this.lang) ? `/${this.lang}` : "no";
            let host = this.internal
                ? "https://www.edrawsoft.cn/order/recharge-page.html"
                : `https://www.edrawsoft.com${availableLang}/pricing-ai-edrawmax.html`;
            if (!this.internal && availableLang == "no") {
                host = "https://edrawmax.wondershare.com/store/pricing-ai.html";
            }
            if (!this.internal && this.lang == "en") {
                // 仅en跳转固定链接
                host = "https://www.edrawmax.com/store/effects-buy.html";
            }
            let custom = encodeURIComponent(btoa(JSON.stringify({ id: this.userInfo.user_id, token: this.userInfo.token })));
            return `${host}?product=max&platform=maxonline&custom=${custom}`;
        }
        aidrawMessageHandle(e) {
            const key = e.data.key ? e.data.key.split("_") : [],
                params = e.data.params;
            let prefix = key[0] || "";
            if (prefix == "aidraw") {
                const str = key[1];
                if (str == "moveDialog") {
                    (this.$refs.dialogDom as any).moveOutside(params[0], params[1]);
                } else if (str == "webUserInfo") {
                    this.postMessageToFrame({
                        key: "userInfo",
                        params: JSON.stringify({
                            user_id: this.userInfo.id,
                            token: this.userInfo.token,
                        }),
                    });
                } else if (str == "closeWin") {
                    this.closeDialog();
                } else if (str == "insertImg") {
                    this.insertImg(params);
                    this.$bus.$emit("refreshAIPoint");
                } else if (str == "toAipoints") {
                    let newTab = window.open("about:blank");
                    newTab.location.href = this.pointLink;
                } else if (str == "uiLoaded") {
                    this.uiPromiseRs();
                } else if (str == "trackStr") {
                    let obj = JSON.parse(params[0]);
                    let label = JSON.parse(obj.label);
                    this.sensors.track(
                        obj.action,
                        Object.assign(
                            {
                                Catalogues: "AiDrawing",
                            },
                            label
                        )
                    );
                } else if (str == "insertTrackStr") {
                    this.insertImgTrackObj = JSON.parse(params[0]);
                }

                if (str == "openUrl") {
                    let newTab = window.open("about:blank");
                    newTab.location.href = params;
                }
            }
        }
        insertImgTrackObj = null;
        insertImg(urlArray) {
            let url = urlArray[0];
            let params = { url };
            const getImageSize = (url) => {
                let u = new URL(url).searchParams;
                return {
                    width: parseInt(u.get("width")) || 0,
                    height: parseInt(u.get("height")) || 0,
                };
            };
            let temp = this.insertImgTrackObj;
            this.insertImgTrackObj = null;
            const track = () => {
                this.sensors.track("AI_painting_inserted_into_canvas", {
                    Catalogues: "AI",
                });
                this.sensors.track("addAiDrawingtToCanva", {
                    Catalogues: "AiDrawing",
                    mode: temp.mode,
                    style: temp.style,
                });
            };
            this.$edApi.getInternetImage(params).then((res) => {
                let view = window["_view"];
                // url 可能是 base64, 也可能没有包含suffix 信息
                let suffix = "";
                if (url.startsWith("data:image/")) {
                    let pos = url.indexOf(";");
                    if (pos !== -1) {
                        suffix = url.substring(11, pos);
                    } else {
                        suffix = url.substr(11, 3);
                    }
                } else {
                    suffix = ".png"; //url.split('.').pop();
                }
                let size = getImageSize(url);
                if (size.width != 0) {
                    view.insertImageFromOL(res, suffix, true, false, 0, 0, size.width, size.height).then(() => {
                        this.$edMessage.success(this.$tc("success"));
                        track();
                    });
                } else {
                    view.insertImageFromOL(res, suffix).then(() => {
                        this.$edMessage.success(this.$tc("success"));
                        track();
                    });
                }
            });
        }
        postMessageToFrame(msg) {
            (this.$refs.aidrawWin as HTMLIFrameElement).contentWindow.postMessage(msg, "*");
        }
        aidrawWinLoad() {
            this.sensors.track("open_AI_painting", {
                Catalogues: "AI",
            });
        }
        setAidrawOption(data) {
            this.uiPromise.then(() => {
                this.postMessageToFrame({
                    key: "setOption",
                    params: data,
                });
            });
        }
        uiPromise = null;
        uiPromiseRs = null;
        created() {
            this.uiPromise = new Promise((rs, rj) => {
                this.uiPromiseRs = rs;
            });
        }
        mounted() {
            this.$bus.$on("setAidrawOption", this.setAidrawOption);
            window.addEventListener("message", this.aidrawMessageHandle);
        }
        beforeDestroy() {
            this.$bus.$off("setAidrawOption", this.setAidrawOption);
            window.removeEventListener("message", this.aidrawMessageHandle);
        }
    }
</script>

<i18n>
{
    "zh": {
        "success": "插入成功"
    },
    "en": {
        "success": "Success"
    },
    "fr": {
        "success": "Succès"
    },
    "de": {
        "success": "Erfolg"
    },
    "jp": {
        "success": "成功"
    },
    "es": {
        "success": "Éxito"
    },
    "pt": {
        "success": "Sucesso"
    },
    "it": {
        "success": "Successo"
    }
}
</i18n>
